<template>
  <div class="interaction-container">
    <label @click="handleDropDownClick()">
      {{ label }}
    </label>
    <div class="dropdown__container" ref="dropdownContainer">
      <div class="dropdown">
        <div class="selected_wrapper" @click="handleDropDownClick()">
          <span class="dropdown_label" v-if="activeOption && !isOpen">
            {{ activeOption }}
          </span>
          <span class="dropdown_label" v-else>
            {{ emptyOption }}
          </span>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none" class="chevron" :class="{ active: isOpen }">
            <path d="M1.33789 0.647461L0.837891 1.02164L7.16904 7.35279L13.5002 1.02164L12.9629 0.647461L7.16904 6.39746L1.33789 0.647461Z" fill="currentColor"/>
          </svg>
        </div>
        <dropdown-wrapper :open="isOpen">
          <div class="option_container" ref="option_container">
            <div
              v-for="option in this.options"
              :key="option"
              class="option"
              :class="{ active: displayedOption === option }"
              :data-option-val="option"
              @click="handleOptionClicked(option)"           
            >
              {{ option }}
            </div>
          </div>        
        </dropdown-wrapper>
      </div>
    </div>
  </div>
</template>
<script>
import DropdownWrapper from "./DropdownWrapper.vue";
export default {
  components: { DropdownWrapper },
  name: "CustomizerVariantDropdown",
  props: {
    // isOpen: {
    //   type: Boolean,
    //   default: false,
    // },
    labelFunction: {
      type: String,
    },
    displayImage: {
      type: Boolean,
      default: false,
    },
    isThumbnail: {
      type: Boolean,
      default: false,
    },
    optionFunction: {
      type: String,
    },
    defaultValueFunction: {
      type: String,
    },
    setFunction: {
      type: String,
    },
    emptyOptionFunction: {
      type: String,
    },
    activeOptionFunction: {
      type: String,
    },
    windowEvent: {
      type: String,
    },
    valueKey: {
      type: String
    }
  },
  data() {
    return {
      displayedOption: null,
      isOpen: false,
    };
  },
  created() {
    this.displayedOption = this.activeOption;
  },
  watch: {
    isOpen(newIsOpen) {
      if (newIsOpen) {
        const scrollTarget = this.$el.querySelector(
          `[data-option-val=${JSON.stringify(this.activeOption)}]` // Using stringify to escape characters
        );
        if (scrollTarget) {
          this.$refs.option_container.scrollTop =
            scrollTarget.offsetHeight * this.options.indexOf(this.activeOption);
        }
      }
    },
  },
  computed: {
    label() {
      return this.$store.getters[this.labelFunction](this.valueKey);
    },
    options() {
      return this.$store.getters[this.optionFunction](this.valueKey);
    },
    activeOption() {
      return this.$store.getters[this.activeOptionFunction](this.valueKey);
    },
    defaultValue() {
      return this.$store.getters[this.defaultValueFunction];
    },
    emptyOption() {
      return this.$store.getters[this.emptyOptionFunction](this.valueKey);
    },
  },
  methods: {
    handleDropDownClick() {
      if (this.isOpen) {
        this.isOpen = false
        // this.$emit("close-dropdown");
        document.removeEventListener('click', this.handleWindowClicked)
      } else {
        this.isOpen = true
        // this.$emit("open-dropdown");
        document.addEventListener('click', this.handleWindowClicked)
      }
    },
    handleWindowClicked(e) {
      if (!this.$refs.dropdownContainer.contains(e.composedPath()[0])) {
        this.handleDropDownClick()
      }
    },
    handleOptionHover(option) {
      this.displayedOption = option;
    },
    handleOptionClicked(option) {
      this.displayedOption = option;
      this.$store.dispatch(this.setFunction, { option, key: this.valueKey });
      if (this.windowEvent) {
        window.dispatchEvent(new Event(this.windowEvent));
      }
      this.$emit("option-changed");
    },
  },
};
</script>
<style scoped>
.dropdown {
  padding: 5px 15px;
  border-radius: 25px;
  border: var(--border-thickness) solid;
  cursor: pointer;
  max-width: 220px;
  margin-left: auto;
  width: calc(100% - 30px);
}
.dropdown_label {
  flex-grow: 1;
  text-align: left;
  user-select: none;
  position: relative;
  text-transform: capitalize;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%; 
}
.selected_wrapper {
  display: flex;
  align-items: center;
}
.option_container {
  text-align: left;
  padding-top: 10px;
}
.option {
  margin-bottom: 2px;
  user-select: none;
  font-size: 12px;
  font-weight: 500;
  line-height: 125%;
}
.option:not(.active):hover,
.option.active {
  text-decoration-line: underline;
}
.additional_detail {
  margin: 10px 0;
}
.image_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.image_wrapper img {
  width: 100%;
  min-height: 150px;
  object-fit: cover;
}
.chevron {
  height: 1rem;
  transition: 0.4s ease-in-out;
}
.chevron.active {
  transform: rotate(180deg);
}
.details_wrapper {
  margin-top: 10px;
  text-align: left;
  padding: 10px;
  user-select: none;
  background-color: var(--option-details-background);
  color: var(--text-color, #2C2B2A);
  font-family: Visby;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%; 
}
.option--1 {
  z-index: 30;
}
.option--2 {
  z-index: 20;
}
.option--3 {
  z-index: 10;
}
@media screen and (min-width: 1180px) {
  .details_wrapper {
    padding: 15px;
    font-size: 14px;
  }
  .dropdown__container {
    max-width: unset;
    width: calc(100% - 30px);
  }
}
</style>
